import React, { useContext, useEffect, useRef } from "react";
import { ThemeContext } from "../context/ThemeContext";

const withColors = (Component) => {
  return (props) => {
    const { onHeightChange } = props;
    const { theme } = useContext(ThemeContext);
    const colors = theme.colors;
    const ref = useRef(null);

    useEffect(() => {
      if (ref.current && onHeightChange) {
        onHeightChange(ref.current.clientHeight);
      }
    }, [onHeightChange]);

    return (
      <div ref={ref}>
        <Component {...props} colors={colors} />
      </div>
    );
  };
};

export default withColors;
